export function enableTooltips(root = document) {
    getTooltipElements(root).forEach((tooltipTriggerEl) => {
        bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl);
    });
}

export function disposeTooltips(root = document) {
    getTooltipElements(root).forEach((tooltipTriggerEl) => {
        const instance = bootstrap.Tooltip.getInstance(tooltipTriggerEl);
        if (instance) {
            instance.dispose();
        }
    });
}

export function formatTimestamp(unixTimestamp) {
    return new Date(unixTimestamp * 1000).toLocaleString();
}

export function formatTimeRange(startTimestamp, endTimestamp) {
    const start = new Date(startTimestamp * 1000);
    const end = new Date(endTimestamp * 1000);
    if (start.toDateString() === end.toDateString()) {
        return `${start.toLocaleDateString()}, ${start.toLocaleTimeString()} - ${end.toLocaleTimeString()}`;
    }
    return `${start.toLocaleString()} - ${end.toLocaleString()}`;
}

export function unixToISO(unixTimestamp) {
    return new Date(unixTimestamp * 1000).toISOString();
}

function getTooltipElements(root) {
    if (!root) {
        return [];
    }
    const base = root;
    const elements = [];
    if (base.matches && base.matches('[data-bs-toggle="tooltip"]')) {
        elements.push(base);
    }
    if (base.querySelectorAll) {
        base.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => elements.push(el));
    }
    return elements;
}
